const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const apiConfig = require('../../api-config');
const base64 = require('base-64');
const { Base64 } = require('js-base64');

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    'Content-Type': 'application/json',
  };
  const reqOpts = { headers, method: 'POST' };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getBankDetails(details, metaData) {
      const url = getUrl('bankDetailsLookup');
      const bankDetails = details.split("#@#");
      const ibanSelected = bankDetails[5] == "true" ? true : false;
      const reqOpts = {headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        language:parsedMetaData.portfolio.language,
        branchCode: apiConfig.branchCode,
        searchTermBankName:bankDetails[0], 
        searchTermNtnlId:bankDetails[1], 
        searchTermCity:bankDetails[2], 
        searchTermPostalCode:bankDetails[3], 
        ibanOrAccountNo:bankDetails[4], 
        isIBAN: ibanSelected,
        txSubType: bankDetails[6].split('-')[0],
        searchCounty: bankDetails[7],
        searchSwiftCode: bankDetails[8],
        sortCode: bankDetails[9]
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },
    
    getCountryList(country, metaData) {
      const url = getUrl('searchCountry');
      const reqOpts = {headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        branchCode: apiConfig.branchCode,
        searchTerm: country,
        language: parsedMetaData.portfolio.language,
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    getBeneficiaryList(inputParam, metaData) {
      const url = getUrl('beneficiaryList');
      const reqOpts = {headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const parameters = JSON.parse(Base64.decode(inputParam));
      
      const body = {
        userId: parsedMetaData.qs.userId,
        paymentType: parameters.paymentType,
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));

    },

    getFilterLists (metaData) {
      const url = getUrl('filterListsLookup');
      const reqOpts = {headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: apiConfig.branchCode,
        language: parsedMetaData.portfolio.language
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));

    },

    listTransactions(inputs,metaData) {
      const url = getUrl('listTransactions');
      const reqOpts = {headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const input = inputs.split("#@#");

      const filterLookUp = input[3]?JSON.parse(base64.decode(input[3])):{}; // EBANK-11646 -Add request param to get filter results
      const body = {
        userId: parsedMetaData.qs.userId,
        channel: input[1],
        deviceCode: input[0],
        fetchMultisig: input[2],
        branchCode: apiConfig.branchCode,
        language: parsedMetaData.portfolio.language,
        filterLookUp,
      };
      
     
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },
    viewPaymentOrder(inputs,metaData) {
      const url = getUrl('viewPaymentOrder');
      const reqOpts = {headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const params = JSON.parse(Base64.decode(inputs));

      const body ={
        userId:params.userId,
        paymentUUID:params.paymentUUID,
        deviceCode: params.deviceCode,
        channel: params.channel,
        branchCode: apiConfig.branchCode,
        language: params.language,
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body, json: true },
        parsedMetaData
      ));
           
    },

    addBeneficiaryDetails(inputParam, metaData) {
      const url = getUrl('addBeneficiary');
      let parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const body = JSON.parse(Base64.decode(inputParam));
      body.beneficiary.cityName = body.beneficiary.city;
      
      return requestHandler(merge(
        {},
        reqOpts, { url, body }
      ));
    },

    editBeneficiaryDetails(inputParam, metaData) {
      const url = getUrl('updateBeneficiary');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const body = JSON.parse(Base64.decode(inputParam));
      if(!body.beneficiary.cityName) {
        body.beneficiary.cityName = body.beneficiary.city;
      }
      return requestHandler(merge(
        {},
        reqOpts, { url, body },
        parsedMetaData
      ));
    },

    deleteBeneficiary(inputParam, metaData) {
      const benfId = JSON.parse(Base64.decode(inputParam));
      const url = getUrl('deleteBeneficiary/' + `${benfId.beneficiaryId}`);
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {};
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      return requestHandler(merge(
        {},
        reqOpts, { url, body},
        parsedMetaData
      ));
    },

    getTemplateList(metaData) {
      const url = getUrl('templateList');
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        language: parsedMetaData.portfolio.language,
      };
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));

    },

    deleteTemplate(inputParam, metaData) {
      const tempId = JSON.parse(base64.decode(inputParam));
      const url = getUrl('deleteTemplate/' + `${tempId.templateId}`);
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {};
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      return requestHandler(merge(
        {},
        reqOpts, { url, body},
        parsedMetaData
      ));
    },

    saveUpdateTemplate(inputParam, metaData) {
      const url = getUrl('updatePaymentTemplate');
      const parsedMetaData = parseRequestMetaData(metaData);
      const decodedObj = JSON.parse(base64.decode(inputParam));
      decodedObj.userId = parsedMetaData.qs.userId;
      const body = decodedObj;
      
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      return requestHandler(merge(
        {},
        reqOpts, { url, body},
        parsedMetaData
      ));
    },

    getStandingOrderList(inputs,metaData) {
      const url = getUrl('listStandingOrderTx');
      const reqOpts = {headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const inputParam = Base64.decode(inputs)
      const input = inputParam.split("#@#");
      const body = {
        userId: parsedMetaData.qs.userId,
        channel: input[1],
        deviceCode: input[0],
        branchCode: apiConfig.branchCode,
        language: parsedMetaData.portfolio.language,
        portfolioId: parsedMetaData.portfolio.pfRelId
      };
     
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },
  };
}

module.exports = apiFactory;